import { render, staticRenderFns } from "./watchInfo.vue?vue&type=template&id=4af63fc1&scoped=true&"
import script from "./watchInfo.vue?vue&type=script&lang=js&"
export * from "./watchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af63fc1",
  null
  
)

export default component.exports